import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { TaskResolutionNoteAttachment } from '../../../app/interfaces/task/task-resolution-note-attachment';
import { Gallery, GalleryItem, GalleryRef, ImageItem, VideoItem } from 'ng-gallery';
import { TaskService } from '../../../app/services/tasks/task.service';
import { AuthenticationService } from '../../../app/services/base/authentication.service';
import { takeUntil } from 'rxjs/operators';
import { ServerResponse } from '../../../app/interfaces/base/server.response';
import { Subject } from 'rxjs';
import { ApiService } from '../../../app/services/base/api.service';
import { TaskResolutionNote } from '../../../app/interfaces/task/task-resolution-note';
import { Task } from '../../../app/interfaces/task/task';

@Component({
  selector: 'fury-attachments',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AttachmentComponent implements OnDestroy, AfterViewInit {

  @Input() class: 'wide' = null;
  @Input() task: Task = null;
  @Input() resolutionNote: TaskResolutionNote = null;

  @Output() destroy: EventEmitter<boolean> = new EventEmitter<boolean>();

  public galleryMedia: GalleryItem[] = [];
  public galleryReportRef: GalleryRef = null;
  public isRotatingPhoto: number[] = [];
  public isDownloading: number[] = [];

  public galleryId = 'attachments-gallery-' + Math.random().toString(36).substr(2, 9);

  private destroy$: Subject<null> = new Subject<null>();

  constructor(
    private taskService: TaskService,
    public authenticationService: AuthenticationService,
    private api: ApiService,
    private cd: ChangeDetectorRef,
    public gallery: Gallery,
  ) {
    this.galleryReportRef = this.gallery.ref(this.galleryId);
  }

  ngAfterViewInit(): void {
    let index: number = 0;

    this.resolutionNote.attachments.all.forEach((item: TaskResolutionNoteAttachment, noteIndex: number): void => {
      if (item.type === 'video') {
        this.galleryMedia.push(new VideoItem({
          src: <any>[
            {
              url: item.src + '?ngsw-bypass=true',
              type: item.mime,
            }
          ],
          thumb: '/assets/img/video.jpg'
        }));
      } else if (item.type === 'image') {
        this.galleryMedia.push(new ImageItem({
          src: item.src,
          thumb: item.src,
        }));
      }

      if (item.type === 'image' || item.type === 'video') {
        this.resolutionNote.attachments.all[noteIndex].galleryIndex = index++;
      }
    });
    this.galleryReportRef.load(this.galleryMedia);
  }

  downloadAttachment(attachmentId: number, index: number): void {
    this.isDownloading.push(index);
    this.cd.detectChanges();

    this.taskService.downloadResolutionNoteAttachment(this.task.id, this.resolutionNote.id, attachmentId);

    setTimeout((): void => {
      const downloadingIndex: number = this.isDownloading.findIndex((d: number): boolean => d === index);
      if (downloadingIndex !== -1) {
        this.isDownloading.splice(downloadingIndex, 1);
      }
      this.cd.detectChanges();
    }, 1500);
  }

  rotatePhoto(direction: 'counter-clockwise' | 'clockwise', id: number, index: number): void {
    this.isRotatingPhoto.push(index);
    this.taskService.rotatePhoto(this.resolutionNote.id, id, direction).pipe(takeUntil(this.destroy$)).subscribe(
      (response: ServerResponse): void => {
        if (!this.api.isErrorResponse(response)) {
          this.galleryMedia.splice(index, 1, new ImageItem({
            src: response.data.src,
            thumb: response.data.thumb
          }));
          this.galleryReportRef.load(this.galleryMedia);
          this.resolutionNote.attachments.all.splice(index, 1, response.data);
          this.resolutionNote.attachments.media.splice(index, 1, response.data);
        }

        const loadingIndex: number = this.isRotatingPhoto.findIndex((d: number): boolean => d === index);
        if (loadingIndex !== -1) {
          this.isRotatingPhoto.splice(loadingIndex, 1);
        }
        this.cd.detectChanges();
      },
      (): void => {
        const loadingIndex: number = this.isRotatingPhoto.findIndex((d: number): boolean => d === index);
        if (loadingIndex !== -1) {
          this.isRotatingPhoto.splice(loadingIndex, 1);
        }
        this.cd.detectChanges();
      });
  }

  deleteAttachment(mediaType: 'media' | 'documents', attachmentId: number): void {
    this.taskService.deleteHandlingAttachment(this.task.id, this.resolutionNote.id, attachmentId).subscribe((result: boolean): void => {
      if (result) {
        if (mediaType === 'media') {
          const attachment: TaskResolutionNoteAttachment = this.resolutionNote.attachments.all.find((d: TaskResolutionNoteAttachment): boolean => d.id === attachmentId),
            attachmentIndex: number = this.resolutionNote.attachments.all.findIndex((d: TaskResolutionNoteAttachment): boolean => d.id === attachmentId),
            itemIndex: number = this.galleryMedia.findIndex((d: GalleryItem): boolean => attachment && d.data.src === attachment.src);

          if (attachmentIndex !== -1) {
            this.resolutionNote.attachments.all.splice(attachmentIndex, 1);
          }

          if (itemIndex !== -1) {
            this.gallery.ref('report').remove(itemIndex);
          }
        } else {
          const attachmentIndex: number = this.resolutionNote.attachments.all.findIndex((d: TaskResolutionNoteAttachment): boolean => d.id === attachmentId);

          if (attachmentIndex !== -1) {
            this.resolutionNote.attachments.all.splice(attachmentIndex, 1);
          }
        }
      }
    });
  }

  removeAttachment(): void {
    this.destroy.emit(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
